import React, { useState, useEffect } from 'react';
import { api, openIspis, Narudzbenica, Stavka } from '../api';
import 'bootstrap/dist/css/bootstrap.min.css';

function formatHr(num: number): string {
  return num.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export default function PregledModal({ id, onClose }: { id: number; onClose: () => void }) {
  const [narudzbenica, setNarudzbenica] = useState<Narudzbenica | null>(null);
  const [stavke, setStavke] = useState<Stavka[]>([]);
  const [loading, setLoading] = useState(true);
  const [ispisLoading, setIspisLoading] = useState(false);

  useEffect(() => {
    api.narudzbenice.view(id).then((r) => {
      setNarudzbenica(r.narudzbenica);
      setStavke(r.stavke);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [id]);

  if (loading || !narudzbenica) {
    return (
      <div className="modal show d-block" tabIndex={-1}>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body text-center py-5">Učitavanje...</div>
          </div>
        </div>
      </div>
    );
  }

  const n = narudzbenica;

  return (
    <div className="modal show d-block" tabIndex={-1} style={{ zIndex: 1055 }}>
      <div className="modal-backdrop show" style={{ zIndex: 1050 }} onClick={onClose} />
      <div className="modal-dialog modal-xl" style={{ zIndex: 1056 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header bg-info text-white">
            <h5 className="modal-title">Pregled narudžbenice</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>Broj:</strong> {n.broj_narudzbenice}<br />
                <strong>Tip:</strong> {n.tip_nabave}<br />
                <strong>Datum:</strong> {new Date(n.datum).toLocaleDateString('hr-HR')}
              </div>
              <div className="col-md-6">
                {n.sastavio_ime ? <><strong>Sastavio:</strong> {n.sastavio_ime}<br /></> : null}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <>
                  <h6 className="bg-warning p-2">KUPAC</h6>
                  <strong>{n.kupac_naziv}</strong><br />
                  <span style={{ whiteSpace: 'pre-wrap' }}>{(n.kupac_adresa || '').toString()}</span>
                  <br />OIB: {n.kupac_oib}<br />
                  {n.kupac_iban ? `IBAN: ${n.kupac_iban}` : null}
                </>
              </div>
              <div className="col-md-6">
                <>
                  <h6 className="bg-warning p-2">ISPORUČITELJ</h6>
                  <strong>{n.isporucitelj_naziv}</strong><br />
                  <span style={{ whiteSpace: 'pre-wrap' }}>{(n.isporucitelj_adresa || '').toString()}</span>
                  <br />OIB: {n.isporucitelj_oib}
                </>
              </div>
            </div>
            <h6 className="bg-warning p-2">STAVKE</h6>
            <table className="table table-bordered table-sm">
              <thead className="table-light">
                <tr>
                  <th>R.BR.</th>
                  <th>Naziv</th>
                  <th>JM</th>
                  <th>Količina</th>
                  <th>Cijena</th>
                  <th>Rabat %</th>
                  <th>PDV</th>
                  <th>Iznos</th>
                </tr>
              </thead>
              <tbody>
                {stavke.map((s, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{s.naziv_dobra_usluge}</td>
                    <td>{s.jed_mjere}</td>
                    <td className="text-end">{formatHr(Number(s.kolicina))}</td>
                    <td className="text-end">{formatHr(Number(s.cijena_bez_pdv))} €</td>
                    <td className="text-end">{formatHr(Number(s.rabat_postotak || 0))}%</td>
                    <td className="text-center">{s.pdv_stopa}%</td>
                    <td className="text-end">{formatHr(Number(s.iznos))} €</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="row mt-3">
              <div className="col-md-6">
                {n.nacin_otpreme && <><strong>Isporuka:</strong> {n.nacin_otpreme}<br /></>}
                {n.rok_isporuke && <><strong>Rok isporuke:</strong> {n.rok_isporuke}<br /></>}
                {n.nacin_placanja && <><strong>Način plaćanja:</strong> {n.nacin_placanja}<br /></>}
                {n.platiti_u_roku && <><strong>Platiti u roku:</strong> {n.platiti_u_roku}</>}
              </div>
              <div className="col-md-6">
                <div className="p-3 bg-light rounded">
                  <strong>Ukupno bez PDV-a:</strong> {formatHr(Number(n.ukupno_bez_pdv))} €<br />
                  <strong>PDV:</strong> {formatHr(Number(n.pdv_iznos))} €<br />
                  <strong>UKUPNO s PDV-om:</strong> {formatHr(Number(n.ukupno_s_pdv))} €
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Zatvori</button>
            <button type="button" className="btn btn-primary" onClick={async () => { setIspisLoading(true); try { await openIspis(id); } finally { setIspisLoading(false); } }} disabled={ispisLoading}>
              {ispisLoading ? 'Učitavanje...' : 'Ispiši'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
